import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const AccordionArrowUp: React.FC<Props> = () => {
  return (
    <SVGIcon width="18" height="12" viewBox="0 0 18 12" fill="none">
      <path
        d="M1 9.49914L1.98133 10.4805L9 3.4618L16.0187 10.4805L17 9.49914L9.49067 1.9898L9 1.52047L8.50933 1.9898L1 9.49914Z"
        fill="#212121"
        stroke="#555555"
      />
    </SVGIcon>
  );
};

export default AccordionArrowUp;
